import React from 'react';
import * as colors from '../../styles/colors';
import { createAbsoluteContainerStyle, createContainerStyle, createInnerSpinnerStyle } from './createStyle';
var defaultProps = {
  color: colors.black,
  className: '',
  size: 2.2,
  transparent: false,
  dataTestId: ''
};
export var Spinner = function Spinner(_a) {
  var _b = _a.color,
      color = _b === void 0 ? defaultProps.color : _b,
      _c = _a.className,
      className = _c === void 0 ? defaultProps.className : _c,
      _d = _a.size,
      size = _d === void 0 ? defaultProps.size : _d,
      _e = _a.dataTestId,
      dataTestId = _e === void 0 ? defaultProps.dataTestId : _e;
  return React.createElement("div", {
    className: createContainerStyle({
      className: className,
      color: color,
      size: size
    })
  }, React.createElement("span", {
    "data-testid": dataTestId,
    className: createInnerSpinnerStyle({
      color: color,
      size: size
    })
  }));
};
export var AbsoluteSpinner = function AbsoluteSpinner(_a) {
  var _b = _a.color,
      color = _b === void 0 ? defaultProps.color : _b,
      _c = _a.transparent,
      transparent = _c === void 0 ? defaultProps.transparent : _c,
      _d = _a.className,
      className = _d === void 0 ? defaultProps.className : _d,
      _e = _a.size,
      size = _e === void 0 ? defaultProps.size : _e,
      _f = _a.dataTestId,
      dataTestId = _f === void 0 ? defaultProps.dataTestId : _f;
  return React.createElement("div", {
    className: createAbsoluteContainerStyle({
      className: className,
      transparent: transparent,
      size: size,
      color: color
    })
  }, React.createElement("span", {
    "data-testid": dataTestId,
    className: createInnerSpinnerStyle({
      color: color,
      size: size
    })
  }));
};